import { Link, makeStyles } from "@material-ui/core";

const HTTP_NOT_AUTHED_STATUS_CODE = 401;

const useStyles = makeStyles((theme) => ({
  link: {},
}));

export const AuthenticationErrorRenderer: React.FC<{ error: any }> = ({
  error,
}) => {
  const classes = useStyles();

  return (
    <>
      It looks like the link you are using has expired.{" "}
      <Link className={classes.link} href={window.location.href}>
        Click here
      </Link>{" "}
      to reload the page and try again.
    </>
  );
};

export const authenticationErrorRenderer = (error: any) => {
  const isAuthHttpError =
    error && error.status && error.status === HTTP_NOT_AUTHED_STATUS_CODE;
  if (!isAuthHttpError) {
    return null;
  }
  return <AuthenticationErrorRenderer error={error} />;
};
